module.exports = function () {
    if (!('MktoForms2' in window)) {
        return;
    }

    window._mfq = window._mfq || [];

    MktoForms2.whenReady(function (form) {
        try {
            require('./setup-form-values')(form);
            require('./setup-form-submit')(form);
            require('./setup-form-display')(form);

            var botUserAgents = [
                'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/152.0.7977.54 Safari/537.36'
            ];

            var isBot = false;
            if (typeof (navigator) !== 'undefined') {
                if (typeof (navigator.userAgent) !== 'undefined') {
                    if (navigator.userAgent.includes('HeadlessChrome') && navigator.userAgent.includes('Linux')) {
                        isBot = true;
                    }
                    else if (botUserAgents.includes(navigator.userAgent)) {
                        isBot = true;
                    }
                }
                if (!isBot && typeof (navigator.webdriver) !== 'undefined' && navigator.webdriver) {
                    isBot = true;
                }
            }

            if (isBot) {
                form.submittable(false);
            }
        }
        catch (error) {
            console.log(error);
        }
    });
};